import { render, staticRenderFns } from "./VueDataTable.vue?vue&type=template&id=c450cb14&scoped=true"
import script from "./VueDataTable.vue?vue&type=script&lang=js"
export * from "./VueDataTable.vue?vue&type=script&lang=js"
import style0 from "./VueDataTable.vue?vue&type=style&index=0&id=c450cb14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c450cb14",
  null
  
)

export default component.exports